import React from 'react';

const ContextProviderUtilities = (defaultValue = undefined) => {
    const Context = React.createContext(defaultValue);

    const useContext = () => {
        const ctx = React.useContext(Context);

        if (ctx === undefined) {
            throw new Error('useContext must be inside a Provider with a value');
        }

        return ctx;
    };

    return [useContext, Context.Provider];
};

export default ContextProviderUtilities;
